import { useMyOffersList } from '@/features/offers/hooks';
import { useRegisterGAPageView } from '@/hooks';

import { MyOffersItems } from '../items';

export function MyOffersContent() {
  const { data: offers, isLoading } = useMyOffersList();
  useRegisterGAPageView('My offers list');

  if (!offers) return null;

  return <MyOffersItems offers={offers} isLoading={isLoading} />;
}
